import FilterEntity from '@/shared/enums/FilterEntity';
import FilterProperty from '@/shared/enums/FilterProperty';

/**
 * Returns the filter entity from the entity or property provided.
 * @param {String} entity
 * @param {String} property
 *
 * @return {String};
 */
export default function getFilterEntityType(entity, property) {
  if (
    entity === FilterEntity.ACTIVITY ||
    property === FilterProperty.ACTIVITY
  ) {
    return FilterEntity.ACTIVITY;
  }
  if (entity === FilterEntity.ROLE || property === FilterProperty.ROLE) {
    return FilterEntity.ROLE;
  }
  if (entity === FilterEntity.GROUP || property === FilterProperty.GROUP) {
    return FilterEntity.GROUP;
  }
  if (entity === FilterEntity.PEOPLE || property === FilterProperty.PEOPLE) {
    return FilterEntity.PEOPLE;
  }
  if (entity === FilterEntity.PROCESS) {
    // Process filter applies to activities via their library activity's process_id
    return FilterEntity.ACTIVITY;
  }
}
